(() => {
    const STORAGE_KEY = 'starumi-mobile-search-history';
    const HISTORY_LIMIT = 8;

    const initializeStarumiSearchOverlay = () => {
        const overlay = document.querySelector('.starumi-mobile-search-overlay');
        const input = overlay?.querySelector('[data-starumi-mobile-search-input]');
        const form = overlay?.querySelector('[data-starumi-mobile-search-form]');
        const historyList = overlay?.querySelector('[data-starumi-search-history-list]');
        const clearButton = overlay?.querySelector('[data-starumi-search-history-clear]');

        if (!overlay || !input || !form || !historyList || overlay.dataset.starumiReady === 'true') return;
        overlay.dataset.starumiReady = 'true';

        let returnFocus = null;

        const readHistory = () => {
            try {
                const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
                return Array.isArray(saved) ? saved.filter((item) => typeof item === 'string').slice(0, HISTORY_LIMIT) : [];
            } catch (error) {
                return [];
            }
        };

        const renderHistory = () => {
            historyList.replaceChildren(...readHistory().map((term) => {
                const link = document.createElement('a');
                link.className = 'starumi-mobile-search-history-item';
                link.href = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(term)}`;
                link.textContent = term;
                link.dataset.starumiSearchTerm = term;
                return link;
            }));
        };

        const saveTerm = (term) => {
            const normalized = term.trim();
            if (!normalized) return;
            const history = readHistory().filter((item) => item.toLocaleLowerCase() !== normalized.toLocaleLowerCase());
            history.unshift(normalized);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, HISTORY_LIMIT)));
            renderHistory();
        };

        const syncQueryState = () => {
            overlay.querySelector('.starumi-mobile-search-predictive')?.classList.toggle('has-query', input.value.trim().length > 0);
        };

        document.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-search-mobile]');
            if (trigger && !overlay.contains(trigger)) returnFocus = trigger;

            const termLink = event.target.closest('[data-starumi-search-term]');
            if (termLink) saveTerm(termLink.dataset.starumiSearchTerm || termLink.textContent || '');
        }, true);

        form.addEventListener('submit', () => saveTerm(input.value));
        input.addEventListener('input', syncQueryState);

        clearButton?.addEventListener('click', () => {
            localStorage.removeItem(STORAGE_KEY);
            renderHistory();
        });

        const bodyObserver = new MutationObserver(() => {
            const isOpen = document.body.classList.contains('open_search_mobile');
            document.body.classList.toggle('starumi-mobile-search-open', isOpen);
            overlay.setAttribute('aria-hidden', String(!isOpen));

            if (isOpen) {
                window.setTimeout(() => input.focus({ preventScroll: true }), 50);
            } else if (returnFocus) {
                returnFocus.focus({ preventScroll: true });
                returnFocus = null;
            }
        });

        bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        renderHistory();
        syncQueryState();
        overlay.setAttribute('aria-hidden', String(!document.body.classList.contains('open_search_mobile')));
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeStarumiSearchOverlay, { once: true });
    } else {
        initializeStarumiSearchOverlay();
    }
})();
